// ANGULAR
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CUSTOM MODULES
import { PopupNotificationModule } from './pages/popup-notification/popup-notification.module';

// EXTERNAL MODULES
import { ToastrModule } from 'ngx-toastr';

/**
 * This module is used for all core modules
 * For core component purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) core module created
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PopupNotificationModule,
    ToastrModule.forRoot(),
  ],
  exports: [PopupNotificationModule],
})
export class CoreModule { }
